import Appointment from 'model/Appointment'
import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'

export class AppointmentRepository extends WebRepository<Appointment> {
  constructor() {
    super(new Api('appointments'))
  }

  // Fuzzy search for patient appointments. Used for patient appointment search bar
  async searchPatientAppointments(patientId: string, text: string): Promise<Appointment[]> {
    return super.search({
      selector: {
        $and: [
          {
            patientId,
          },
          {
            $or: [
              {
                location: {
                  $regex: '(?i)' + text,
                },
              },
              {
                reason: {
                  $regex: '(?i)' + text,
                },
              },
              {
                type: {
                  $regex: '(?i)' + text,
                },
              },
            ],
          },
        ],
      },
    })
  }

  async searchAppointmentRelatedAppointments(appointmentId: string): Promise<Appointment[]> {
    return super.search({
      selector: {
        $and: [
          {
            previous_appointment: appointmentId,
          },
        ],
      },
      limit: 10,
    })
  }
}

export default new AppointmentRepository()
